import { jsxs as o, jsx as e } from "react/jsx-runtime";
import { Icon as m } from "@tameeni/icons";
import { cn as u } from "@tameeni/shared-logic";
import { Animated as i, Carousel as h, CarouselContent as f, CarouselItem as p } from "@tameeni/ui";
import b from "react";
function I(a) {
  return /* @__PURE__ */ e(p, { className: "basis-auto p-2 grayscale hover:grayscale-0 cursor-pointer transition-all", children: a.children });
}
function M(a) {
  const { children: l, locale: r, includedSponsors: c = [] } = a, d = {
    IA: /* @__PURE__ */ e(
      n,
      {
        title: r === "ar" ? "مرخص من" : "Authorized by",
        subtitle: r === "ar" ? "هيئة التأمين" : "Insurance Authority",
        icon: "IA"
      }
    ),
    Monshaat: /* @__PURE__ */ e(
      n,
      {
        title: r === "ar" ? "برعاية" : "Sponsored by",
        subtitle: r === "ar" ? "منشآت" : "Monsha'at",
        icon: "Monshaat"
      }
    ),
    Mazaya: /* @__PURE__ */ e(
      n,
      {
        title: r === "ar" ? "متاح على" : "Available by",
        subtitle: r === "ar" ? "خدمات مزايا" : "Mazaya services",
        icon: "Mazaya"
      }
    )
  };
  return /* @__PURE__ */ o("div", { className: "flex flex-col border-b border-slate-100", children: [
    /* @__PURE__ */ e("div", { className: "py-4 gap-4 flex justify-center border-b border-slate-100", children: c.map((s, t) => /* @__PURE__ */ e(
      i.SlideIn,
      {
        direction: r === "ar" ? "right" : "left",
        useScroll: !0,
        transition: { delay: t * 0.15 },
        children: d[s]
      }
    )) }),
    /* @__PURE__ */ e(
      h,
      {
        className: "box w-full py-4",
        opts: {
          align: "center",
          dragFree: !0
        },
        children: /* @__PURE__ */ e(f, { className: u(a.isCentered && "center"), children: b.Children.map(l, (s, t) => /* @__PURE__ */ e(
          i.BlurReveal,
          {
            className: "h-full",
            useScroll: !0,
            transition: { delay: t * 0.02 },
            children: s
          },
          t
        )) })
      }
    )
  ] });
}
const n = ({
  title: a = "",
  subtitle: l = "",
  icon: r
}) => /* @__PURE__ */ o("div", { className: "flex flex-col justify-center text-center items-center  md:flex-row gap-4", children: [
  /* @__PURE__ */ e(m, { name: r, className: "w-auto min-w-12 h-8" }),
  /* @__PURE__ */ o("div", { className: "h-full justify-between flex flex-col", children: [
    /* @__PURE__ */ e("p", { className: "text-c1 text-slate-400 mb-0", children: a }),
    /* @__PURE__ */ e("p", { className: "text-s3", children: l })
  ] })
] });
export {
  I as PartnerItem,
  M as default
};
//# sourceMappingURL=index.js.map
